<template>
  <b-card>
    <div
      class="table-header-border-bottom pb-1 mb-md-3 d-flex justify-content-between align-items-center"
    >
      <h3 class="mt-1">
        <feather-icon
          icon="LayersIcon"
          class="mr-50"
          style="width: 18px; height: 18px"
        />
        <span>Categories</span>
      </h3>
      <div class="d-flex">
        <!-- <b-button class="mt-1 mr-50" @click="removeCategories">
          <feather-icon icon="Trash2Icon" />
          <span> Delete </span>
        </b-button> -->
        <b-button class="gradient-btn mt-1" :to="{ name: 'categories-create' }">
          <feather-icon icon="PlusIcon" />
          <span> Create </span></b-button
        >
      </div>
    </div>

    <b-form
      @submit.prevent="filter"
      class="filters rounded p-1 my-md-1 d-flex align-items-center justify-content-between flex-wrap"
    >
      <div class="col-sm-3 col-12 p-50 d-flex align-items-center">
        <!-- <div class="mr-50">
            <b-form-checkbox v-model="selectAll"></b-form-checkbox>
          </div> -->
        <v-select
          :options="types"
          v-model="type"
          label="label"
          :reduce="(option) => option.value"
          :searchable="false"
          placeholder="Display on the page"
          class="w-100"
        ></v-select>
      </div>

      <div class="col-sm-6 col-12 d-flex align-items-center p-50">
        <b-form-input
          placeholder="search"
          v-model.trim="search"
          :disabled="!type"
        />
      </div>
      <div class="col-sm-3 col-12 p-50">
        <b-button class="w-100" type="submit" :disabled="!search">
          <span class="text-muted h5"> Filtering</span>
        </b-button>
      </div>
    </b-form>

    <data-table :fields="fields" :items="categories" :loading="loading">
      <template #selectCategories="{ data }">
        <div class="d-flex">
          <div class="pr-50 border-right mr-75">
            <!-- <b-form-checkbox
              v-model="removeCategoriesData"
              :value="data.item.id"
            ></b-form-checkbox> -->
            <span class="font-weight-bold h5 mb-0">{{ data.item.id }}</span>
          </div>
        </div>
      </template>

      <template #title="{ data }">
        <span style="white-space: nowrap">{{ data.item.title }}</span>
      </template>

      <template #description="{ data }">
        <span class="text-truncate mb-0">
          {{ data.item.description || "-" }}
        </span>
      </template>
      <template #active="{ data }">
        <b-badge :variant="data.item.active ? 'light-success' : 'light-danger'">
          {{ data.item.active ? "Active" : "Not active" }}
        </b-badge>
      </template>
      <template #symbol="{ data }">
        <span>
          {{ data.item.symbol || "-" }}
        </span>
      </template>
      <template #starting_balance="{ data }">
        <span>
          {{
            data.item.starting_balance
              ? Number(data.item.starting_balance).toFixed(2) + " $ "
              : "-"
          }}
        </span>
      </template>

      <template #minimum_trade="{ data }">
        {{ data.item.minimum_trade || "-" }}
      </template>
      <template #draw_down="{ data }">
        {{
          data.item.draw_down
            ? Number(data.item.draw_down).toFixed(2) + "%"
            : "-"
        }}
      </template>
      <template #profit="{ data }">
        <span>
          {{ data.item.profit || "-" }}
        </span>
      </template>
      <template #max_participant="{ data }">
        {{ data.item.max_participant || "-" }}
      </template>
      <template #duration="{ data }">
        {{ data.item.duration || "-" }}
      </template>
      <template #actions="{ data }">
        <div class="nowrap-white-space">
          <b-dropdown no-caret class="d-flex d-xl-none more-option">
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" />
            </template>
            <b-dropdown-item
              variant="flat-primary"
              :to="{
                name: 'categories-edit',
                params: {
                  id: data.item.id,
                },
              }"
            >
            <div class="d-flex align-items-center w-100">
              <feather-icon icon="EditIcon" class="mr-50" />Edit
            </div>
            </b-dropdown-item>
          </b-dropdown>
          <div class="d-xl-flex d-none">
            <b-button
              variant="flat-primary"
              class="mx-25"
              :to="{
                name: 'categories-edit',
                params: {
                  id: data.item.id,
                },
              }"
              ><feather-icon icon="EditIcon" />Edit</b-button
            >
            <!-- <b-button
            class="mx-25"
            variant="flat-danger"
            @click="removeCategory(data.item)"
          >
            <feather-icon icon="TrashIcon" />
            <span class="ml-50">Delete</span>
          </b-button> -->
          </div>
        </div>
      </template>
    </data-table>

    <div
      class="w-100 d-flex flex-wrap align-items-center justify-content-between"
    >
      <b-pagination
        v-model="currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        size="lg"
        pills
        class="my-2 d-flex justify-content-center"
      >
      </b-pagination>
    </div>
  </b-card>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BPagination,
  BLink,
  BCard,
  BFormCheckbox,
  BForm,
  BFormInput,
  BBadge,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VSelect from "vue-select";
import qs from "qs";
export default {
  components: {
    DataTable,
    BButton,
    BModal,
    BCard,
    VBModal,
    BPagination,
    BLink,
    BFormCheckbox,
    BForm,
    BFormInput,
    BBadge,
    VSelect,
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      selectAll: false,
      removeCategoriesData: [],
      url: "/panel/categories",
      currentPage: 1,
      loading: false,
      pagination: {},
      pages: [],
      selectedPage: "",
      types: [
        { label: "Title", value: "title" },
        { label: "Symbol", value: "symbol" },
        // { label: "Starting balance", value: "starting_balance" },
        // { label: "Minimum trade", value: "minimum_trade" },
        // { label: "Draw down", value: "draw_down" },
        // { label: "Profit", value: "profit" },
        // { label: "Max participant", value: "max_participant" },
        // { label: "Duration", value: "duration" },
      ],
      type: "",
      search: "",
      fields: [
        { key: "selectCategories", label: "row" },
        { key: "title", label: "title" },
        { key: "active", label: "active" },
        { key: "symbol", label: "symbol" },
        { key: "starting_balance", label: "starting balance" },
        { key: "minimum_trade", label: "minimum trade" },
        { key: "draw_down", label: "draw down" },
        { key: "profit", label: "profit" },
        { key: "max_participant", label: "max participant" },
        { key: "duration", label: "duration" },
        { key: "actions", label: "operation" },
      ],
      categories: [],
    };
  },
  directives: {
    "b-modal": VBModal,
  },
  watch: {
    async type(val) {
      this.search = await "";
      if (this.$route.fullPath != "/categories") {
        this.$router.push({
          name: "categories",
        });
      }
    },
    currentPage(val) {
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "categories",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    $route: {
      handler(val) {
        this.removeCategoriesData = [];
        this.getCategories();
      },
      immediate: true,
      deep: true,
    },
    selectAll: {
      handler(val) {
        val
          ? (this.removeCategoriesData = this.categories.map(
              (category) => category.id
            ))
          : (this.removeCategoriesData = []);
      },
      immediate: true,
    },
    removeCategoriesData: {
      handler(val) {
        val.length == this.categories.length && (this.selectAll = true);
        val.length == 0 && (this.selectAll = false);
      },
      deep: true,
    },
    search(val) {
      if (!val) {
        if (this.$route.query.filter) {
          let filter = {};
          this.$router.push({
            name: "categories",
            query: {
              filter,
            },
          });
        }
      }
    },
  },
  created() {
    if (this.$route.query.filter) {
      this.$router.push({
        name: "categories",
        query: {},
      });
    }
  },
  methods: {
    filter() {
      if (this.type) {
        let filter = {};
        filter[this.type] = this.search;
        this.$router.push({
          name: "categories",
          query: {
            ...this.$route.query,
            filter,
          },
        });
      } else if (this.$route.fullPath != "/categories") {
        this.$router.push({
          name: "categories",
        });
      }
    },
    removecategories(item) {
      this.$bvModal
        .msgBoxConfirm("Are you sure about deleting this option ?", {
          size: "sm",
          bodyClass: "h5 my-2",
          okVariant: "primary",
          okTitle: "Yes",
          cancelTitle: "No",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            this.loading = true;
            try {
              await this.$http.delete(`/panel/categories/${item.id}`);
              if (!this.$route.query.page || this.$route.query.page == 1) {
                this.removeCategoriesData = [];
                await this.getCategories();
              } else {
                await this.$router.push({
                  name: "categories",
                  query: { page: 1 },
                });
                this.currentPage = await this.$route.query.page;
              }
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Your option has been deleted successfully.",
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } catch (err) {
              this.$toast(
                {
                  component: ToastificationContent,
                  props: {
                    title: "There is some problem",
                    icon: "InfoIcon",
                    variant: "danger",
                  },
                },
                { position: "bottom-right" }
              );
            }
            this.loading = false;
          }
        });
    },
    removeCategories() {
      if (this.removeCategoriesData.length) {
        this.$bvModal
          .msgBoxConfirm("Are you sure about deleting these options ?", {
            size: "sm",
            bodyClass: "h5 my-2",
            okVariant: "primary",
            okTitle: "Yes",
            cancelTitle: "No",
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          })
          .then(async (value) => {
            if (value) {
              this.loading = true;
              try {
                await this.removeCategoriesData.map(
                  async (faq) =>
                    await this.$http.delete(`/panel/categories/${faq}`)
                );
                if (!this.$route.query.page || this.$route.query.page == 1) {
                  this.removeCategoriesData = [];
                  await this.getCategories();
                } else {
                  await this.$router.push({
                    name: "categories",
                    query: { page: 1 },
                  });
                  this.currentPage = await this.$route.query.page;
                }
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Your options have been deleted successfully.",
                    icon: "EditIcon",
                    variant: "success",
                  },
                });
              } catch (err) {
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "There is some problem",
                      icon: "InfoIcon",
                      variant: "danger",
                    },
                  },
                  { position: "bottom-right" }
                );
              }
              this.loading = false;
            }
          });
      } else {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "No option selected ",
              icon: "InfoIcon",
              variant: "danger",
            },
          },
          { position: "bottom-right" }
        );
      }
    },
    async getCategories() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
        };
        const { data } = await this.$http.get(this.url, {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.categories = data.data;
        this.pagination = await data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
